import { Box, Button, Stack, Typography, useMediaQuery } from '@mui/material'
import { specialOfferesGrid1Data, specialOfferesGrid2Data } from 'src/resources/data/landingPageData'

import React from 'react'
import { content } from 'src/common/lang/en-US'
import { useNavigate } from 'react-router-dom';

const SpecialOffers: React.FC = () => {
    const { title } = content.landingPage.specialOffers;
    const navigate = useNavigate();
    const xsScreen = useMediaQuery('(max-width:700px)');

    return (
        <Box py={4} px={xsScreen ? 2 : 10}>
            <Stack direction="row" justifyContent="center">
                <Stack direction="column" alignItems="center" gap={4}>
                    <Typography variant='subtitle1' fontWeight={500}>{title}</Typography>
                    <Box border="1px solid red" width="8rem" />
                </Stack>
            </Stack>

            <Box
                bgcolor="primary.light"
                color="primary.dark"
                display="grid"
                width="100%"
                gridTemplateColumns={{
                    xs: '1fr',
                    sm: 'repeat(2, 1fr)',
                    md: 'repeat(2, 1fr)'
                }}
                mt={8}
            >
                {specialOfferesGrid1Data.map((offer) => (
                    <Stack width="100%" direction={xsScreen ? "column" : "row"}>
                        <Stack p={{ xs: 1, sm: 2, md: 4 }} width={xsScreen ? "100%" : "50%"} direction="column">
                            <Typography variant='h4_Thin'>
                                {offer.title}
                            </Typography>
                            <Typography variant='h6' fontWeight={300} color='body.mediumGray' lineHeight={1.7}>
                                {offer.subTitle.length > 150
                                    ? `${offer.subTitle.slice(0, 150)}...`
                                    : offer.subTitle}
                            </Typography>
                            <Button
                                onClick={() => navigate(offer.link)}
                                sx={{
                                    backgroundColor: "#ea728c",
                                    color: "#FFFFFF",
                                    borderRadius: "30px",
                                    py: "8px",
                                    mt: 4,
                                    fontSize: "14px",
                                    width: "7rem"
                                }}
                            >
                                Learn More
                            </Button>
                        </Stack>
                        <img
                            src={offer.image}
                            alt="ChooseUsBanner"
                            style={{ maxWidth: xsScreen ? "100%" : '50%', height: '100%', objectFit: 'cover', }}
                        />
                    </Stack>
                ))}
            </Box>
            <Box
                bgcolor="primary.light"
                color="primary.dark"
                display="grid"
                width="100%"
                gridTemplateColumns={{
                    xs: '1fr',
                    sm: 'repeat(2, 1fr)',
                    md: 'repeat(2, 1fr)'
                }}
            >
                {specialOfferesGrid2Data.map((offer) => (
                    <Stack width="100%" direction={xsScreen ? "column" : "row"}>
                        {!xsScreen && <img
                            src={offer.image}
                            alt="ChooseUsBanner"
                            style={{ maxWidth: xsScreen ? "100%" : '50%', height: '100%', objectFit: 'cover', }}
                        />}
                        <Stack p={{ xs: 1, sm: 2, md: 4 }} width={xsScreen ? "100%" : "50%"} direction="column">
                            <Typography variant='h4_Thin'>
                                {offer.title}
                            </Typography>
                            <Typography variant='h6' fontWeight={300} color='body.mediumGray' lineHeight={1.7}>
                                {offer.subTitle.length > 150
                                    ? `${offer.subTitle.slice(0, 150)}...`
                                    : offer.subTitle}
                            </Typography>
                            <Button
                                onClick={() => navigate(offer.link)}
                                sx={{
                                    backgroundColor: "#ea728c",
                                    color: "#FFFFFF",
                                    borderRadius: "30px",
                                    py: "8px",
                                    mt: 4,
                                    fontSize: "14px",
                                    width: "7rem"
                                }}
                            >
                                Learn More
                            </Button>
                        </Stack>
                        {xsScreen && <img
                            src={offer.image}
                            alt="ChooseUsBanner"
                            style={{ maxWidth: xsScreen ? "100%" : '50%', height: '100%', objectFit: 'cover', }}
                        />}
                    </Stack>
                ))}
            </Box>
        </Box>
    )
}

export default SpecialOffers